export const needLoginApi = [
  '/bapi/v3/kyc/campaign/fiat/window'
];